<template>
	<div>
		<el-row :gutter="20">
			<el-col :span="5">
				<div class="search-view">
					<div>试卷名称：</div>
					<el-input size="mini" placeholder="试卷名称" v-model="entity.title" clearable />
				</div>
			</el-col>
			<el-col :span="5">
				<div class="search-view">
					<div>试卷状态：</div>
					<el-select v-model="entity.status" size="mini" clearable placeholder="全部">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div>
			</el-col>
			<el-col :span="5">
				<el-button type="primary" size="mini" @click="chaxun()">查询</el-button>
				<el-button type="success" size="mini" icon="el-icon-plus" @click="tj()">增加</el-button>
				<el-button type="warning" size="mini" @click="zhikong()">置空</el-button>
			</el-col>
		</el-row>
		<el-table :data="tableDate">
			<el-table-column label="试卷id" prop="id"></el-table-column>
			<el-table-column label="试卷标题" prop="title"></el-table-column>
			<el-table-column label="关联课时" prop="relatedCourseName"></el-table-column>
			<el-table-column label="试卷总分" prop="totalScore"></el-table-column>
			<el-table-column label="创建日期" prop="createdAt"></el-table-column>
			<el-table-column label="状态" prop="status">
				<template slot-scope="scope">
					<el-switch :active-value="1" :inactive-value="0" @change="isStatus(scope.row)" active-text="启用"
						inactive-text="禁用" v-model="scope.row.status">
					</el-switch>
				</template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button type="text" @click="chakan(scope.row)">
						查看考生
					</el-button>
					<el-button type="primary" size="mini" @click="bj(scope.row)">
						编辑
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div style="margin: 20px auto;width: 500px">
			<el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
				:page-size="pageSize" :page-sizes="pagelist" :total="total" :current-page.sync="pageNum"
				@size-change="handleSizeChange" @current-change="handleCurrentChange" />
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				value: "",
				options: [{
						value: "",
						label: '全部'
					}, {
						value: 0,
						label: '禁用'
					},
					{
						value: 1,
						label: '启用'
					}
				],
				tableDate: [],
				pageNum: 1,
				pageSize: 30,
				total: 0,
				pagelist: [30, 60, 100],
				entity: {
					id: "",
					title: "",
					relatedCourseId: "",
					status: ""
				},
			}
		},
		methods: {
			zhikong() {
				this.entity.title = ''
				this.entity.status = ''
				this.getInfo()
			},
			tj() {
				this.$router.push({
					path: './addClrTest',
					query: {
						cz: 'tj'
					}
				})
			},
			//查看学生
			chakan(row) {
				console.log(row);
				this.$router.push({
					path: './seeStudents',
					query: {
						testParerId: row.id,
						title: row.title
					}
				})
			},
			//编辑
			bj(row) {
				console.log(row);
				this.$router.push({
					path: './addClrTest',
					query: {
						id: row.id,
						title: row.title,
						totalScore: row.totalScore,
						passScore: row.passScore,
						relatedCourseId: row.relatedCourseId,
						relatedCourseName: row.relatedCourseName,
						status: row.status,
						cz: 'bj'
					}
				})

			},
			//查询
			chaxun() {
				this.getInfo()
			},
			//改变状态
			isStatus(row) {
				console.log(row);
				this.$http.post("/api/course/clrTestPaper/update/status", {
					id: row.id,
					status: row.status == 0 ? 0 : 1,
				}).then(res => {
					console.log(res);
				})
			},
			//页面的条数发生改变时
			handleSizeChange(size) {
				this.pageSize = size
				//重新请求数据
				this.getInfo()
			},
			//当前页发生改变时
			handleCurrentChange(currentPage) {
				this.pageNum = currentPage
				//重新请求数据
				this.getInfo()
			},
			getInfo() {
				this.$http.post("/api/course/clrTestPaper/select", {
					entity: {
						id: this.entity.id,
						title: this.entity.title,
						relatedCourseId: this.entity.relatedCourseId,
						status: this.entity.status
					},
					page: {
						pageNum: this.pageNum,
						pageSize: this.pageSize
					}
				}).then(res => {
					// console.log(res.data.data.list);
					res.data.data.list.forEach(i => {
						i.status = i.status ? 1 : 0
					})
					this.tableDate = res.data.data.list
					this.total = res.data.data.total
					console.log(this.tableDate);
				})
			}
		},
		created() {
			this.getInfo()
		}
	}
</script>

<style scoped="scoped">

</style>
